import { CreatorViewListPage } from './CreatorViewList.page';

export const creatorViewListRouter = {
  '/@/creator_views': CreatorViewListPage,
};
